module.exports = __webpack_public_path__ + "static/determined-collapsed-2-362dbf10de305866ccc7cf39992d364f.png";